<template>
  <div style="height:100%">
    <el-table :data="data" style="width: 100%;" height="100%">
      <el-table-column prop="id" label="编号" width="150">
      </el-table-column>
      <el-table-column prop="address" label="地址">
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="getTagType(scope.row.status)" size="small">{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="task" label="任务描述">
      </el-table-column>
      <el-table-column label="剩余电量" width="180">
        <template slot-scope="scope">
          <el-progress v-if="scope.row.battery" :text-inside="true" :stroke-width="18" :percentage="scope.row.battery"
            :status="getProgressStatus(scope.row.battery)" style="margin-right:30px;"></el-progress>
          <div v-else>无数据</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="220">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="detail(scope.row)">详细</el-button>
          <el-button type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
          <el-button type="text" size="small" @click="scan([scope.row.id])">扫台</el-button>
          <el-button type="text" size="small" @click="record([scope.row.id])">录音</el-button>
          <el-button type="text" size="small" @click="reboot([scope.row.id])">重启</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import VueEvent from "@/models/VueEvent.js";
  export default {
    components: {},
    data() {
      return {
        dialog: {
          title: "上海市普陀区金沙江路 1518 弄",
          visible: false
        },
        conditions: {},
        data: []
      };
    },
    mounted() {
      VueEvent.$on("addCondition", params => {
        let needUpdata = false;
        if (params.target == "device") {
          for (let cond in params.condition) {
            if (this.conditions[cond] != params.condition[cond]) {
              this.conditions[cond] = params.condition[cond]
              needUpdata = true;
            }

          }
          if (needUpdata) {
            this.getDatas();
          }

        }
      });
    },
    methods: {
      getTagType(text) {
        switch (text) {
          case "空闲":
            return "success";
          case "离线":
            return "info";
        }
      },
      edit(id) {
        VueEvent.$emit("editDevice", {
          lgid: id
        });
      },
      detail(row) {
        //TODO 跳转到设备详情页面
        this.$router.push({
          path: `/DeviceInfo/${row.id}`
        });
      },
      async scan(deviceIdList) {
        let msg = `此操作将对设备 ${deviceIdList.join(",")} 下发扫台任务，是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/apicloud/jpush", {
          devices: deviceIdList,
          command: "scan"
        }).then(res => {
          this.$message.success(`任务下发成功，即时任务号为 ${res.task_id}`);
        });
      },
      async record(deviceIdList) {
        let freqInfo = await this.$prompt("请输入频率（范围：87-108）", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: function (value) {
            let f = Number(value);
            if (isNaN(f)) {
              return "请输入数值";
            }
            if (value.match(/^[0-9]+([.]{1}[0-9]{1})?$/) === null) {
              return "频率为整数或者最多一位小数";
            }
            if (f < 87 || f > 108) {
              return "有效频率范围为87-108";
            }
          },
          inputErrorMessage: "频率格式不正确"
        }).catch(() => {});
        if (freqInfo === undefined) {
          return;
        }

        let recordLengthInfo = await this.$prompt(
          "请输入录音时长（秒）",
          "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputPattern: /^[1-9]\d*$/,
            inputErrorMessage: "录音时长应为正整数"
          }
        ).catch(() => {});
        if (recordLengthInfo === undefined) {
          return;
        }
        let recordLength = recordLengthInfo.value;

        let msg = `此操作将对设备 ${deviceIdList.join(
        ","
      )} 下发录音任务（频率：${freq}、录音时长：${recordLength}），是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/apicloud/jpush", {
          devices: deviceIdList,
          command: "record",
          extra: {
            freq: freq,
            length: recordLength
          }
        }).then(res => {
          this.$message.success(`任务下发成功，即时任务号为 ${res.task_id}`);
        });
      },
      async reboot(deviceIdList) {
        let msg = `此操作将使设备 ${deviceIdList.join(",")} 重启，是否继续？`;
        let confirmInfo = await this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).catch(() => {});
        if (confirmInfo === undefined) {
          return;
        }

        this.$getJSON("/apicloud/jpush", {
          devices: deviceIdList,
          command: "reboot"
        }).then(res => {
          this.$message({
            message: `重启命令下发成功`,
            type: "success"
          });
        });
      },
      getDatas() {
        //从后台查询数据
        this.$getJSON("/terminal/s_devicelst", this.conditions).then(res => {
          this.data = res.data;
          VueEvent.$emit("data_loaded", {
            origin: "device",
            total: res.total
          });
        });
      },
      getProgressStatus(value) {
        if (value >= 50) return "success";
        else if (value < 10) return "exception";
        else return "";
      }
    }
  };

</script>
<style scoped>
  video {
    height: 38px;
    width: 170px;
  }

</style>



// WEBPACK FOOTER //
// src/components/tables/Device.vue